module.exports = __webpack_public_path__ + "static/media/resubmit-icon.d662486b.svg";